// SW003_Robot_Voices_Creature_36_Robot_Speaking_Talking_Gibberish_Babbling_Medium_Register_Cute_Constant_Pitch.wav

import BaseScene from "./BaseScene";

import AmbientBackgroundSounds from "../../assets/audio/ambience.ogg";
import AmbientBackgroundSoundsMP3 from "../../assets/audio/ambience.mp3";
import AmbientBackgroundChatter from "../../assets/audio/SW003_Robot_Voices_Creature_36_Robot_Speaking_Talking_Gibberish_Babbling_Medium_Register_Cute_Constant_Pitch.ogg";
import AmbientBackgroundChatterMP3 from "../../assets/audio/SW003_Robot_Voices_Creature_36_Robot_Speaking_Talking_Gibberish_Babbling_Medium_Register_Cute_Constant_Pitch.mp3";
import NegativeFlickerHitSound from "../../assets/audio/CK_Sensors-13.ogg";
import NegativeFlickerHitSoundMP3 from "../../assets/audio/CK_Sensors-13.mp3";

//not going to spritesheet this scene as we are using pipline effects that break with atlas
import EnemyOne from "../../assets/img/info/hacker-carousel.png";
import EnemyTwo from "../../assets/img/info/clone-carousel.png";
import EnemyThree from "../../assets/img/info/trojan-carousel.png";
import Spotlight from "../../assets/img/info/spotlight.png";
import Particle from "../../assets/img/info/particle.png";

import CharacterAll from "../../assets/img/info/characters-carousel.png";
import CharacterOne from "../../assets/img/info/encryptor.png";
import CharacterTwo from "../../assets/img/info/glitch-character-select.png";
import CharacterThree from "../../assets/img/info/nano-character-select.png";

import { PostPipeline } from "../plugins/global/PostEffectPlugin";
import { PHShape } from "../plugins/global/PlaceholderPlugin";
import UnlockNanoComponent from "../components/ncsc/UnlockNanoComponent";

/*
HOWTO:

- Duplicate the scene with the name of your choice, and then replace 'REPLACEME' with the name of this scene.
- Each scene has access to all of the sponge tools via, this.sponge, as these are all typed classes itellisense will help you (try it!)
- You will need to add the scene to the index.ts to incorporate, as evals are not safe to use anymore.
-

*/

/**
 *
 * @category scenes
 * @export
 * @class InfoIntroScene
 * @extends {BaseScene}
 */
export default class InfoIntroScene extends BaseScene {
  // public somthing:Phaser.GameObjects.Text;

  bgSound: Phaser.Sound.BaseSound;
  bgChatter: Phaser.Sound.BaseSound;
  glitchSound: Phaser.Sound.BaseSound;

  currentEnemy: Phaser.GameObjects.Image;
  spotlight: Phaser.GameObjects.Image;
  nanoCodeComponent: UnlockNanoComponent;

  effects: boolean;

  currentAvatar: number = 0;

  constructor() {
    super({
      key: "InfoIntroScene",
      active: false, // false means this state isn't loaded on boot. true means its instantly activated.
    });
    console.log("InfoIntroScene::constructor");
  }

  /**
   * preload any assets for this state
   *
   *
   * @memberof InfoIntroScene
   */
  preload(): void {
    console.log("InfoIntroScene::preload");
    // load any used assets here, we are going to load per scene to improve memory performance.

    this.load.image("info-enemy-0", EnemyOne);
    this.load.image("info-enemy-1", EnemyTwo);
    this.load.image("info-enemy-2", EnemyThree);

    this.load.image("info-character-0", CharacterAll);
    this.load.image("info-character-1", CharacterOne);
    this.load.image("info-character-2", CharacterTwo);
    this.load.image("info-character-3", CharacterThree);

    this.load.image("info-spotlight", Spotlight);
    this.load.image("info-particle", Particle);

    this.load.audio("ambient-menu-sound", [
      AmbientBackgroundSounds,
      AmbientBackgroundSoundsMP3,
    ]);
    this.load.audio("ambient-menu-chatter", [
      AmbientBackgroundChatter,
      AmbientBackgroundChatterMP3,
    ]);
    this.load.audio("negative-flicker-sound", [
      NegativeFlickerHitSound,
      NegativeFlickerHitSoundMP3,
    ]);

    super.preload();
  }

  /**
   * create any gameObjects that are required here.
   *
   * @memberof InfoIntroScene
   */
  create(): void {
    console.log("InfoIntroScene::create");
    // when scene is first loaded.

    this.sponge.placeholder.image(
      this,
      this.cameras.main.centerX,
      this.cameras.main.centerY,
      PHShape.RECT,
      {
        width: this.cameras.main.width,
        height: this.cameras.main.height,
        radius: 0,
      },
      0x1b1a3d
    );

    this.cameras.main.setBackgroundColor(0x1b1a3d);

    this.add.image(
      this.cameras.main.centerX,
      this.cameras.main.centerY,
      "blurEdge"
    );

    this.bgSound = this.sound.add("ambient-menu-sound", {
      volume: 0.1,
      loop: true,
    });

    this.bgSound.play();

    this.bgChatter = this.sound.add("ambient-menu-chatter", {
      volume: 0.1,
      loop: true,
    });

    this.bgChatter.play();

    this.spotlight = this.add
      .image(this.cameras.main.centerX, -40, "info-spotlight")
      .setOrigin(0.5, 0);

    this.currentEnemy = this.add
      .image(
        this.cameras.main.centerX,
        this.cameras.main.centerY + 145,
        "info-enemy-0"
      )
      .setOrigin(0.5, 1);

    //TODO: if webgl renederer not avalible.

    this.effects = this.sponge.effects.addMainGamePost(this);

    if (this.effects) {
      this.currentEnemy.setFlipY(true).setOrigin(0.5, 0);
      this.currentEnemy.y = this.cameras.main.centerY - 145;
    }

    if (this.effects)
      (this.cameras.main.pipeline as PostPipeline).effectProgress = 0;
    //TODO: if webgl renederer not avalible.

    if (this.effects) this.sponge.effects.addGlitch(this.currentEnemy);

    this.glitchSound = this.sound.add("negative-flicker-sound", {
      volume: 0.3,
      loop: false,
    });

    const emitter = this.add.particles("info-particle").createEmitter({
      name: "info-particle",
      x: { min: 0 + 80, max: this.cameras.main.width - 80 },
      y: { min: 0, max: 720 },
      speed: { min: 0, max: 10 },
      angle: 90,
      alpha: {
        onUpdate: (p, k, t, v) => {
          return 0.5 - Math.abs(t - 0.5);
        },
      },
      lifespan: 3000,
      scale: { min: 0.1, max: 0.8 },
      frequency: 150,
    });

    this.sponge.popup.events.on("loadPage", (page: number) => {
      console.log("Load page", page);
      this.spotlight.setScale(0.1, 0);
      this.tweens.add({
        targets: this.spotlight,
        scale: 1,
        duration: 150,
      });

      this.currentEnemy.setTexture("info-enemy-" + page);
      this.glitch();
    });

    // timeout hack to trigger showEnemyDetails AFTER the scene is set to active
    setTimeout(() => {
      this.showEnemyDetails();
    }, 100);
  }

  showEnemyDetails() {
    this.sponge.popup.launchPopup("enemy-intros", () => {
      console.log("popup dismissed");

      this.sponge.popup.events.off("loadPage");

      this.showCharacterSelect();
    });
  }

  showCharacterSelect() {
    this.currentAvatar = this.sponge.data.save.characterSelect;

    this.spotlight.setScale(0.1, 0);
    this.tweens.add({
      targets: this.spotlight,
      scale: 1,
      duration: 150,
    });
    this.currentEnemy.setTexture("info-character-" + this.currentAvatar);

    this.sponge.popup.events.on("loadPage", (page: number) => {
      console.log("Load page", page);
      this.currentAvatar = page;

      this.spotlight.setScale(0.1, 0);
      this.tweens.add({
        targets: this.spotlight,
        scale: 1,
        duration: 150,
      });

      this.currentEnemy.setTexture("info-character-" + this.currentAvatar);
      this.glitch();
    });

    this.sponge.popup.launchPopup("character-select", () => {
      // TODO

      if (this.currentAvatar == 3) {
        // if nano show nano code input component to unlock him
        this.nanoCodeComponent = new UnlockNanoComponent(this);
        this.nanoCodeComponent.on("submitCode", this.unlockNano, this);
      } else {
        // set avatar if character is not nano
        this.setAvatar();
      }
    });
  }

  unlockNano(codeCorrect: boolean) {
    this.nanoCodeComponent.destroy();
    if (codeCorrect) {
      this.setAvatar();
    } else {
      this.showCharacterSelect();
    }
  }

  setAvatar() {
    const avRef = this.currentAvatar == 0 ? 0 : this.currentAvatar - 1;
    this.sponge.data.save.characterSelect = avRef;
    console.log("setAvatar", this.sponge.data.save.characterSelect);
    this.sponge.tracking.save();
    this.sponge.popup.events.off("loadPage");
    this.shutdown();
  }

  glitch() {
    if (this.currentEnemy && this.glitchSound && this.effects) {
      (this.currentEnemy.pipeline as PostPipeline).fire(this, 400, 0.2);
      this.glitchSound.play();
    }
  }

  /**
   * Sleep is called when switching away from this state, use to pause this state
   * but with the potential to resume later, called when using state.run, state.switch, state.sleep
   *
   * @memberof InfoIntroScene
   */
  sleep(): void {
    //hide any game objects when we transition out of this state.
  }

  /**
   * used for when a state is awoken from it's sleep state, called when using state.run, state.switch, state.sleep
   *
   * @memberof InfoIntroScene
   */
  wake(): void {
    //wake / show game objects as we transition into this state.
  }

  /**
   * update is called on each frame, when the scene is in an active, non sleep state.
   *
   * @param {number} time time since app launch
   * @param {number} delta miliseconds since update.
   * @memberof InfoIntroScene
   */
  update(time: number, delta: number): void {
    super.update(time, delta);
  }

  /**
   * destroy and remove this scene from memory.
   *
   * @memberof InfoIntroScene
   */
  shutdown(): void {
    console.log("InfoIntroScene::shutdown");

    this.bgSound.stop();
    this.bgChatter.stop();
    this.sponge.stopVO();

    // drop references to anything we have in create

    // try {
    // this.somthing.destroy();
    // this.somthing = undefined;
    // } catch (e) {
    //   console.warn("error trying to destroy somthing", e);
    // }

    // finally shutdown our state
    this.scene.switch("EndlessRunnerScene");
  }
}
